import { BlastEvent, SimulationConfig } from '@/types';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const CometTailAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 40; i++) {
    const sa = Math.random() * Math.PI * 2;
    const d = progress * (800 + Math.random() * 800);
    ctx.fillRect(e.pos.x + Math.cos(sa) * d, e.pos.y + Math.sin(sa) * d, 4, 4);
  }
};

registerBlastAnimation('COMET_TAIL', CometTailAnimation);
